import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import { MGMT_OBJECTIVE_LIST, MGMT_OBJECTIVE_ADD, MGMT_OBJECTIVE_DETAIL, MGMT_OBJECTIVE_UPDATE } from '../../actions';
import {
  MgmtObjectiveListSuccess, MgmtObjectiveListError,
  MgmtObjectiveAddSuccess, MgmtObjectiveAddError,
  MgmtObjectiveDetailSuccess, MgmtObjectiveDetailError,
  MgmtObjectiveUpdateSuccess, MgmtObjectiveUpdateError
} from '../../actions';

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => { unsubscribe(); resolve(token); });
    }, reject);
  });
}

const onListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'management/objective/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};
const onAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'management/objective/add', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data.payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { message: true, data: response };
};
const onDetailAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'management/objective/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};
const onUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'management/objective/update', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  }).then(r => r.json()).catch(err => console.log(err));
  return { message: true, data: response };
};

function* onList(data) {
  try { const response = yield call(onListAsync, data.payload); yield put(MgmtObjectiveListSuccess(response.data)); }
  catch (error) { yield put(MgmtObjectiveListError(error)); }
}
function* onAdd(data) {
  try {
    const response = yield call(onAddAsync, data);
    if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    else if (response.data.status === 'error') NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    yield put(MgmtObjectiveAddSuccess(response.data));
  } catch (error) { yield put(MgmtObjectiveAddError(error)); }
}
function* onDetail(data) {
  try { const response = yield call(onDetailAsync, data.payload); yield put(MgmtObjectiveDetailSuccess(response.data.data)); }
  catch (error) { yield put(MgmtObjectiveDetailError(error)); }
}
function* onUpdate(data) {
  try {
    const response = yield call(onUpdateAsync, data.payload);
    if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    else if (response.data.status === 'error') NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    yield put(MgmtObjectiveUpdateSuccess(response.data));
  } catch (error) { yield put(MgmtObjectiveUpdateError(error)); }
}

export function* watchList() { yield takeEvery(MGMT_OBJECTIVE_LIST, onList); }
export function* watchAdd() { yield takeEvery(MGMT_OBJECTIVE_ADD, onAdd); }
export function* watchDetail() { yield takeEvery(MGMT_OBJECTIVE_DETAIL, onDetail); }
export function* watchUpdate() { yield takeEvery(MGMT_OBJECTIVE_UPDATE, onUpdate); }

export default function* rootSaga() {
  yield all([fork(watchList), fork(watchAdd), fork(watchDetail), fork(watchUpdate)]);
}
